// image_bundle_tagで画像を使うため一括import（reismディレクトリ配下の画像ファイルのみ）
function allRequire(context) {
  context.keys().forEach(context);
}
allRequire((require).context('@image/reism/', true, /\.(png|jpg|jpeg|gif|svg)$/)) // eslint-disable-line

// KVスライドショーの初期化（横スクロール）
function initKvSlideshow() {
  const slideshow = document.querySelector('.kv__slideshow');
  if (!slideshow) return;

  const container = slideshow.querySelector('.kv__slideshow-container');
  if (!container) return;

  const slides = container.querySelectorAll('.kv__slide');
  if (slides.length === 0) return;

  let currentIndex = 0;
  // 各スライドはコンテナの25%の幅なので、1枚移動するごとに25%移動
  const slideWidthPercent = 100 / slides.length; // 4枚なら25%

  const updateSlidePosition = () => {
    const translateX = -currentIndex * slideWidthPercent;
    container.style.transform = `translateX(${translateX}%)`;
  };

  const nextSlide = () => {
    currentIndex = (currentIndex + 1) % slides.length;
    updateSlidePosition();
  };

  // 初期位置を設定（最初のスライドを表示）
  updateSlidePosition();

  // 2秒ごとに自動スライド
  setInterval(nextSlide, 2000);
}

// ご利用の流れ「もっと詳しく」開閉
function initServiceFlowMore() {
  const moreDisplay = document.querySelector('.service-flow__more--display');
  const moreHidden = document.querySelector('.service-flow__more--hidden');
  if (!moreDisplay || !moreHidden) return;

  moreDisplay.addEventListener('click', (event) => {
    if (!event.currentTarget.classList.contains('service-flow__more--display')) return;

    document.querySelectorAll('.service-flow__text-item--hidden').forEach((el) => {
      el.style.display = 'block';
    });

    const transparentTarget = document.querySelector('[data-target="transparent-target"]');
    if (transparentTarget) {
      transparentTarget.classList.remove('service-flow__text-item--transparent');
    }

    moreDisplay.style.display = 'none';
    moreHidden.style.display = 'flex';
  });

  moreHidden.addEventListener('click', (event) => {
    if (!event.currentTarget.classList.contains('service-flow__more--hidden')) return;

    document.querySelectorAll('.service-flow__text-item--hidden').forEach((el) => {
      el.style.display = 'none';
    });

    const transparentTarget = document.querySelector('[data-target="transparent-target"]');
    if (transparentTarget) {
      transparentTarget.classList.add('service-flow__text-item--transparent');
    }

    moreHidden.style.display = 'none';
    moreDisplay.style.display = 'flex';
  });
}

// DOMContentLoaded後にスライドショーを初期化・ご利用の流れを初期化
document.addEventListener('DOMContentLoaded', () => {
  initKvSlideshow();
  initServiceFlowMore();
});
